import { Menu } from 'antd'
import { ThreeDotsMenu } from '../../../../components/ThreeDotsMenu'
import { Typography } from '../../../../components/Typography'
import { BTN_TXT } from '../../../../constants'
import { useFinancialsPopup } from 'features/Financials/Providers/FinancialsPopupProvider'
import { CognusARData } from './types'

export const CognusARTableMenu = ({
  row,
  canCompleteMarketplaceARPayment,
  canInitiateMarketplaceARPayment
}: {
  row: CognusARData
  canCompleteMarketplaceARPayment: boolean
  canInitiateMarketplaceARPayment: boolean
}) => (
  <ThreeDotsMenu className="actual-saving-menu">
    <CognusARTableMenuItems
      row={row}
      canCompleteMarketplaceARPayment={canCompleteMarketplaceARPayment}
      canInitiateMarketplaceARPayment={canInitiateMarketplaceARPayment}
    />
  </ThreeDotsMenu>
)

const CognusARTableMenuItems = ({
  row,
  canCompleteMarketplaceARPayment,
  canInitiateMarketplaceARPayment
}: {
  row: CognusARData
  canCompleteMarketplaceARPayment: boolean
  canInitiateMarketplaceARPayment: boolean
}) => {
  const { confirmMarketplaceARPaymentPopup } = useFinancialsPopup()

  return (
    <Menu className="menu-items-wrapper actual-savings-menu" selectedKeys={[]}>
      {canInitiateMarketplaceARPayment && (
        <Menu.Item
          key="pay"
          onClick={() => confirmMarketplaceARPaymentPopup.actions.open({ row })}
        >
          <Typography.Body1>{BTN_TXT.PAY}</Typography.Body1>
        </Menu.Item>
      )}
      {canCompleteMarketplaceARPayment && (
        <Menu.Item key="complete_marketplace_ar">
          <Typography.Body1>{BTN_TXT.COMPLETE_MARKETPLACE_AR}</Typography.Body1>
        </Menu.Item>
      )}
    </Menu>
  )
}
